module.exports = __webpack_public_path__ + "img/scene.a5653f11.png";